<template>
  <div
    id="app"
    :class="[
      {
        screentest: $store.state.Screentest.isScreentest,
        screentest_graphs: this.$route.query.screentest_graphs,
      },
      UserAgent.browser.name,
      UserAgent.browser.os,
    ]"
  >
    <!--client analytics-->
    <img
      :src="'https://ad.doubleclick.net/ddm/trackimp/N7437.3434815PRIHEALTHCARESOLUTI/B26953163.323396948;dc_trk_aid=519953010;dc_trk_cid=165920516;ord=' + timestamp + ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=?'"
      alt="Advertisement"
      style="position: fixed; left: -1px; top: -1px; opacity: 0"
    >
    <!--end - client analytics-->

    <router-view />
    <transition name="fade">
      <rotate-lock
        v-if="
          this.UserAgent.orientation === 'landscape' &&
          this.UserAgent.window.width <= 1180
        "
      ></rotate-lock>
    </transition>
  </div>
</template>

<script>
// vuex
import { mapState } from "vuex";

// plugins
import { detect } from "detect-browser";

// mixins
import { NoParentScrollMixin } from "@/mixins/NoParentScrollMixin";
import HandleOrientation from "@/mixins/HandleOrientation";
import HandleResize from './mixins/HandleResize';

// components
import rotateLock from "@/components/rotate-lock/rotate-lock";

export default {
  name: "App",
  mixins: [NoParentScrollMixin, HandleOrientation, HandleResize],
  components: {
    rotateLock,
  },
  data: () => ({
    timestamp: Date.now(),
  }),
  computed: {
    ...mapState(["UserAgent"]),
  },
  created() {
    if (!!this.$route.query.screentest) {
      this.$store.dispatch("setScreentest");
    }

    const browser = detect();
    if (browser) {
      this.$store.commit("UPDATE_BROWSER", browser)
    }
  },
  mounted() {
    this.calcVH();
    window.addEventListener('resize', this.iPhoneFixBottomWrapper)
  },
  methods: {
    calcVH() {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    },
    iPhoneFixBottomWrapper() {
      const app = document.getElementById('app');
      const isIphone = typeof app !== 'undefined' && (app.classList.contains('ios') || app.classList.contains('iOS')) && window.innerWidth < 430;
      if ( isIphone ) {
        const iPhoneXnbHidden  = window.innerWidth > 374 && window.innerWidth < 376 && window.innerHeight > 640;
        const iPhone12nbHidden = window.innerWidth > 389 && window.innerWidth < 391 && window.innerHeight > 670;
        if ( iPhoneXnbHidden || iPhone12nbHidden ) {
          app.classList.add('iphone-navbar-hidden')
        } else {
          app.classList.remove('iphone-navbar-hidden')
        }
      }
    }
  },
};
</script>

<style lang="scss" src="./scss/main.scss"></style>
